import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ShopContextProvider from './Context/ShopContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initSentry, initAnalytics, reportWebVitals, sendToAnalytics } from './monitoring';

// Initialise observability as early as possible
initSentry();
initAnalytics();

/**
 * QueryClient — global cache configuration
 *
 * staleTime: 5 min  → cached data is served instantly for 5 minutes
 *                      before a background re-fetch is triggered.
 *                      (Stale-While-Revalidate behaviour built-in.)
 *
 * gcTime:    10 min → unused cache entries stay in memory for 10 minutes
 *                      so navigating Back feels instantaneous.
 *
 * retry: 1          → only retry once on network error (avoids long waits).
 *
 * refetchOnWindowFocus: false → prevents surprise re-fetches when user
 *                               alt-tabs back (annoying in a storefront).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:            5 * 60 * 1000,  // 5 minutes
      gcTime:               10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry:                1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <ShopContextProvider>
      <App />
    </ShopContextProvider>
  </QueryClientProvider>
);

// Report Core Web Vitals to GA4 (only fires in production when GA is configured)
reportWebVitals(sendToAnalytics);
